import { connect } from 'react-redux';
import { withProps, withHandlers, compose, lifecycle } from 'recompose';
import moment from 'moment';
import CampaignVerbiage from '../components/CampaignVerbiage';
import config from '../../../config';
import withTimeZone from '../../auth/utils/withTimezone';

const CampaignVerbiageContainer = compose(
  withTimeZone,
  connect(state => ({
    shops: state.auth.user.shops,
    shopId: state.engagement.campaign.customerGroups[0].shopId,
    shopDefaultName: state.engagement.campaign.customerGroups[0].name,
    isLapsed: state.engagement.campaign.customerGroups.length === 1
      && state.engagement.campaign.customerGroups[0].name === 'lapsing',
  })),
  withHandlers({
    getShopNameById: props => () => {
      if (!props.shopId) return props.shopDefaultName;
      return props.shops.filter(shop => shop.id === props.shopId)[0].name;
    },
  }),
  withProps(props => ({
    displayFrequency: parseInt(props.frequency, 10) === 1 ? 'daily' : 'weekly',
    displayTime: moment(props.time, 'HH:mm:ss').format(config.timeFormat).toUpperCase(),
    displayUserType: props.isLapsed === true ? 'lapsed' : props.getShopNameById() || 'selected',
    displayStartDate: moment(props.startDate).format(config.dateFormat),
    timezone: moment.tz(props.timezone).zoneAbbr(),
  })),
  withHandlers({
    getDayVerbiage: props => () => {
      if (props.displayFrequency === 'daily') return '';

      return moment(props.startDate).format('dddd');
    },
    getEndDate: props => () => {
      if (props.endDate === null) return 'indefinitely';

      return `until ${moment(props.endDate).format(config.dateFormat)}`;
    },
  }),
  lifecycle({
    componentDidMount() {
      if (this.props.onHideEndDatePicker) this.props.onHideEndDatePicker();
    },
  })
)(CampaignVerbiage);

export default CampaignVerbiageContainer;
